import axios from 'axios'
import AuthService from './auth.service'
import httpErrorNotification from './http-error-notification.service'
import router from '@/router'

/**
 * Http Service
 * An axios wrapper with server configuration
 * and automatic error notifications
 * @version 1.0.0
 * @author Fernando Torres
 * @copyright Marciano Studio S.C., 2018
 */
const http = axios.create({
  baseURL: process.env.API_URL
})

/**
 * Add functionality on each request made
 * to the API
 */
http.interceptors.request.use(
  function (config) {
    if (AuthService.token()) {
      config.headers = {
        authorization: AuthService.token()
      }
    }
    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)

/**
 * Add functionality on each response made
 * to the API
 */
http.interceptors.response.use(
  function (response) {
    // Do something with response data
    return response
  },
  function (httpError) {
    // Do something with response error
    if (httpError.response.status === 401) {
      AuthService.logout()
      router.push(AuthService.logoutRoute)
    }
    httpErrorNotification(httpError.response)
    return Promise.reject(httpError)
  }
)

export default http



// WEBPACK FOOTER //
// ./src/services/http.service.js